module.exports = __webpack_public_path__ + "img/events.e1d63879.jpg";